export const getNestedValue = (obj: any, path: string): any => {
    const keys = path.split('.');
    let current = obj;

    for (const key of keys) {
        if (current[key] === undefined) {
            return undefined;
        }
        current = current[key];
    }

    return current;
};

export const setNestedValue = (obj: any, path: string, value: any): void => {
    const keys = path.split('.');
    while (keys.length > 1) {
        const key = keys.shift()!;
        if (!obj[key]) {
            obj[key] = {};
        }
        obj = obj[key];
    }
    obj[keys[0]] = value;
};
